import React, { FC, useEffect, useState } from "react";
import { Input, Modal, Form } from "antd";

import { IMenuSettingModel } from "states/menu-setting/menu-setting.models";
import { useForm } from "antd/lib/form/Form";
import { Store } from "antd/lib/form/interface";
import { UploadFileLocal } from "shared/components/upload-file/upload-file";
import { CoreResource, t } from "shared/plugins/localization";
import { AddTheField, Avatar, Cancel, Classify, ExtensionField, Name, Save, Slug, Sort, TheFieldIsRequired, UpdateTheField } from "shared/constants/define-localization";

interface IMenuSettingChildrenModalProps {
  model: IMenuSettingModel;
  onUpdate: boolean;
  onModal: boolean;
  index?: number;
  onSave: (model: IMenuSettingModel) => void;
  closeModal: () => void;
}
export const MenuSettingChildrenModal: FC<IMenuSettingChildrenModalProps> = (
  props
) => {
  const { model, onUpdate, onModal, index, closeModal, onSave } = props;
  const [isLoading, setLoading] = useState(false);
  const [images, setImages] = useState<string[]>([]);
  const [form] = useForm();
  const handleCloseModal = () => closeModal();
  const onFinish = async (values: Store) => {
    setLoading(true);
    let payload: IMenuSettingModel = {
      ...values,
      id: values.id,
      name: values.name,
      slug: values.slug,
      images: images,
      extensionFields:values.extensionFields,
      sort: values.sort,
      menuType: values.menuType,
      data: values.data??[],
    };
    onSave(payload);
    handleCloseModal();
    setLoading(false);
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const onSubmit = () => {
    form.submit();
  };
  const onReset = () => {
    form.resetFields();
    setImages([]);
  };
  const onFill = () => {
    form.setFieldsValue(model);
    setImages(model?.images??[]);
  };
  useEffect(() => {
    if (!onUpdate) {
      onReset();
    } else {
      onFill();
    }
  }, [onModal]);

  return (
    <div className="menu-setting-modal">
      <Modal
        title={
          <div
            style={{
              width: "100%",
              cursor: "move",
            }}
            onBlur={() => {}}
            // end
          >
            {onUpdate ? t(CoreResource,UpdateTheField, "menu") :  t(CoreResource,AddTheField, "menu")}
          </div>
        }
        confirmLoading={isLoading}
        centered={true}
        visible={onModal}
        onOk={onSubmit}
        onCancel={handleCloseModal}
        okText={"Lưu"}
        cancelText={"Hủy"}
      >
        <Form
          form={form}
          name="StaffModal"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          labelCol={{ span: 8 }}
          initialValues={{ isActive: true }}
          wrapperCol={{ span: 16 }}
        >
          <Form.Item
            label={t(CoreResource,Name)}
            name="name"
            rules={[{ required: true, message: t(CoreResource,TheFieldIsRequired,"menu") }]}
          >
            <Input className="w-100" placeholder={t(CoreResource,Name)} />
          </Form.Item>
          <Form.Item label={t(CoreResource,Slug)} name="slug">
            <Input className="w-100" placeholder={t(CoreResource,Slug)} />
          </Form.Item>
          <Form.Item label={t(CoreResource,Avatar)} name="avatar">
            <UploadFileLocal
              isUploadImage={true}
              multiple={true}
              album={images}
              onChange={(newFileList) => {
                setImages(newFileList);
              }}
            />
          </Form.Item>
          <Form.Item label={t(CoreResource,Sort)} name="sort">
            <Input className="w-100" placeholder={t(CoreResource,Sort)} />
          </Form.Item>
          <Form.Item label={t(CoreResource,Classify)} name="menuType">
            <Input className="w-100" placeholder={t(CoreResource,Classify)} />
          </Form.Item>
          <Form.Item label="Extension Field" name="extensionFields">
            <Input className="w-100" placeholder={`Extension Field`} />
          </Form.Item>
          <Form.Item hidden={true} name="data">
            <Input  type="hidden"  />
          </Form.Item>
          <Form.Item hidden={true} name="id">
            <Input type="hidden" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
